module.exports = __webpack_public_path__ + "media/Video 61.9730d8a3.mp4";